export default __webpack_public_path__ + "static/sprites-ddcce434b9e0a297bd56e94ad1afe1d9.svg";